import Paper from '@material-ui/core/Paper';
import React from 'react';
import { SoccerIcon } from '~icons';
import { mapSportUidToSportIcon } from '~slices/sports';
import { useStyles } from './RoundPlate.styles';
var RoundPlate = function (_a) {
    var roundName = _a.roundName, sportUid = _a.sportUid, flag = _a.flag;
    var classes = useStyles();
    var SportIcon = (sportUid && mapSportUidToSportIcon[sportUid]) || SoccerIcon;
    return (React.createElement(Paper, { className: classes.container },
        React.createElement("img", { alt: "country flag", src: flag, className: classes.countryFlag }),
        React.createElement("div", { className: classes.divider }),
        React.createElement(SportIcon, null),
        React.createElement("div", null, roundName)));
};
export { RoundPlate };
